import React from 'react'
import { render } from 'react-dom'

import Root from './root/Root.js'
import configureStore from './root/store.js'
import registerServiceWorker from './registerServiceWorker'
import { watchOnlineState } from './offline/actions.js'

// Render an empty div until the token check is done
const appRoot = document.getElementById('app-host')

export const store = configureStore()

// Track browser's online state
watchOnlineState(store)

// Start the app
render(<Root store={store} />, appRoot)
registerServiceWorker()



// WEBPACK FOOTER //
// ./client/src/index.js